import DeliveryDashboardComponent from "@/components/delivery/DeliveryDashboard";

export default function DeliveryDashboardPage() {
  return <DeliveryDashboardComponent />;
}
